import {GetCoinsHistoryHeaderResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {
  COLORS,
  GenericIconName,
  Icon,
  IconName,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CoinsHistoryHeaderView: React.FC<
  GetCoinsHistoryHeaderResponse
> = ({header}) => {
  return (
    <CoinHeaderWrapper>
      <HeaderRow
        data-testid="coinsHistoryAvailableCoins"
        coins={header.availableCoins.coins}
        title={header.availableCoins.title}
        icon={GenericIconName.CoinsFilled}
      />
      <HeaderRow
        coins={header.pendingCoins.coins}
        title={header.pendingCoins.title}
        icon={GenericIconName.CoinsStriped}
      />
    </CoinHeaderWrapper>
  );
};

const HeaderRow: React.FC<{
  ['data-testid']?: string;
  coins: string;
  title: string;
  icon: GenericIconName;
}> = ({'data-testid': dataTestId, coins, title, icon}) => {
  return (
    <HeaderRowWrapper>
      <IconTextWrapper>
        <StyledIcon asset={icon as IconName} size="XS" fill={COLORS.White} />
        <Text size="px12" color="White" weight="mediumHeavy">
          {title}
        </Text>
      </IconTextWrapper>
      <Text
        size="px12"
        color="White"
        weight="mediumHeavy"
        data-testid={dataTestId}
      >
        {coins}
      </Text>
    </HeaderRowWrapper>
  );
};

const StyledIcon = styled(Icon)`
  && {
    height: 1rem;
    width: 1rem;
  }
`;

const IconTextWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const CoinHeaderWrapper = styled.div`
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const HeaderRowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1rem;
`;
